export default __webpack_public_path__ + "static/media/Goshoppi3.cbbba834.png";